import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.4.1_@types+node@22.7.0_db0@0.2.4_eslint@9.12.0_jiti@2.4.2__iore_g3yia44ir4nyz6onx6uueeql5y/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}